import axios from 'axios'
import qs from 'qs'

const BASE_API_PATH = `/api`

export const apiRoutes = {
  quotes: async (params: Record<string, any>) => {
    const url = `${BASE_API_PATH}/quotes/funnel/`
    const { data } = await axios.get(`${url}?${qs.stringify(params)}`)
    return data
  },
  quotesWithoutProductDetermination: async (
    params: Record<string, any>,
    productString?: string
  ) => {
    const url = `${BASE_API_PATH}/quotes/`
    const { data } = await axios.get(
      `${url}?${qs.stringify({
        ...params,
        productString,
      })}`
    )

    return data
  },

  /**
   * Service Worker to handle analytics event delivery in the background.
   * When an event is triggered, the client sends a message to the Service Worker,
   * which then performs the fetch to /api/analytics. This ensures that analytics events are reliably sent even during page unloads or navigations.
   * If the Service Worker fails or is unavailable, the client falls back to sending the event directly via fetch.
   */
  sendAnalyticsEvent: async (eventPayload: Record<string, any>) => {
    const url = `/api/analytics`
    const cookies = document.cookie

    const sentServiceWorker = await sendUsingServiceWorker(
      url,
      eventPayload,
      cookies
    )
    if (!sentServiceWorker) {
      await sendUsingFetchFallback(url, eventPayload, cookies)
    }
  },
}

const sendUsingServiceWorker = async (
  url: string,
  payload: Record<string, any>,
  cookies: string
): Promise<boolean> => {
  if (
    typeof navigator === 'undefined' ||
    !('serviceWorker' in navigator) ||
    !navigator.serviceWorker.controller
  ) {
    return false
  }

  try {
    const response = await Promise.race([
      new Promise<{ success: boolean }>((resolve) => {
        const handleMessage = (event: MessageEvent) => {
          if (event.data?.success === true || event.data?.success === false) {
            navigator.serviceWorker.removeEventListener(
              'message',
              handleMessage
            )
            resolve(event.data)
          }
        }
        navigator.serviceWorker.addEventListener('message', handleMessage)
        navigator.serviceWorker.controller!.postMessage({
          url,
          payload,
          cookies,
        })
      }),
      new Promise<{ success: false }>((resolve) =>
        setTimeout(() => resolve({ success: false }), 3000)
      ),
    ])

    if (response.success) {
      console.log('Analytics event sent via service worker successfully')
      return true
    } else {
      console.warn('Service worker responded with failure, falling back')
      return false
    }
  } catch (error) {
    console.error('Error during service worker analytics send:', error)
    return false
  }
}

const sendUsingFetchFallback = async (
  url: string,
  payload: Record<string, any>,
  cookies: string
) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Cookie: cookies,
      },
      body: JSON.stringify(payload),
      keepalive: true,
    })

    if (!response.ok) {
      console.error('Analytics fallback failed with status:', response.status)
    } else {
      console.log('Analytics event sent via fallback')
    }
  } catch (error) {
    console.error('Analytics fallback failed:', error)
  }
}
